import { BaseModel } from "./base";
import { Veiculo } from "./veiculo";

export default class MarcaChassi extends BaseModel {
  constructor(
    public id: number,
    public nome: string,
    public createdAt: Date,
    public updatedAt: Date,
    public veiculos: Veiculo[]
  ) {
    super(id);
  }
}
